import './theinnatserenbe/style';
import FormStructure from './theinnatserenbe/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js